<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Digitalni kiosk</h3>
                    </template>
                    <base-input label="Grupe">
                        <el-select v-model="kioskGroup" class="select-primary" value-key="id" name="kioskGroups"
                            style="width: 200px" clearable @change="getKiosks()">
                            <el-option v-for="t in kioskGroups" class="select-primary" :label="t.name" :value="t"
                                :key="t.id"></el-option>
                        </el-select>
                        <base-button class="mt-3" native-type="submit" type="primary" @click="editKioskGroup()">
                            <template v-if="kioskGroup">Izmeni grupu</template>
                            <template v-else>Nova grupa</template>
                        </base-button>

                        <base-button v-if="kioskGroup" class="mt-3" native-type="submit" type="danger" @click="deleteGroupPrompt()">
                            <template>Obriši grupu</template>
                        </base-button>
                    </base-input>
                    <base-button class="mt-3" native-type="submit" type="primary"
                        @click="kiosk = {}; editKioskDialog = true">Novi
                        kiosk</base-button>
                    <el-table :data="kiosks" v-loading="kiosksLoading">
                        <el-table-column min-width="100" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="kioskGroup" label="Grupa">
                            <template slot-scope="scope">
                                <span>{{ scope.row.kioskGroup?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="userName" label="Korisničko ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="password" label="Lozinka">
                            <template slot-scope="scope">
                                <span>{{ scope.row.password }}</span>
                            </template>
                        </el-table-column>


                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="kiosk = scope.row; editKioskDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="kiosk = scope.row; deleteKioskPrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>



        <modal :show.sync="editKioskDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editKioskDialog = false; kiosk = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">Digitalni kiosk</h4>
                <form @submit.prevent>
                    <div>

                        <base-input label="Grupe">
                            <el-select v-model="kiosk.kioskGroup" class="select-primary" value-key="id"
                                name="kioskGroups" style="width: 200px" clearable>
                                <el-option v-for="t in kioskGroups" class="select-primary" :label="t.name" :value="t"
                                    :key="t.id"></el-option>
                            </el-select>
                        </base-input>

                        <base-input label="Ime" type="text" v-model="kiosk.name" placeholder="Ime">
                        </base-input>

                        <base-input label="Ime za potvrdu" type="textarea">
                            <textarea placeholder="Ime za potvrdu" v-model="kiosk.kioskName"
                                style="height: 100px; width: 270px;">
                            </textarea>
                        </base-input>

                        <base-input label="Korisničko ime" type="text" v-model="kiosk.userName"
                            placeholder="Korisničko ime">
                        </base-input>

                        <base-input label="Lozinka" type="text" v-model="kiosk.password" placeholder="Lozinka">
                        </base-input>

                        <table>
                            <tr>
                                <td>
                                    <base-input label="Tekst za priznanicu" type="textarea">
                                        <textarea placeholder="Tekst za priznanicu" v-model="kiosk.text"
                                            style="height: 800px; width: 270px;">
                                        </textarea>
                                    </base-input>
                                </td>
                                <td>
                                    <base-input label="Tekst za izvestaj" type="textarea">
                                        <textarea placeholder="Tekst za izvestaj" v-model="kiosk.reportText"
                                            style="height: 800px; width: 270px;">
                                        </textarea>
                                    </base-input>
                                </td>
                                <tr>
                                    <td>
                                        <base-input label="Tekst za storniranje" type="textarea">
                                            <textarea placeholder="Tekst za priznanicu" v-model="kiosk.stornoText"
                                                style="height: 800px; width: 270px;">
                                            </textarea>
                                        </base-input>
                                    </td>
                                </tr>
                            </tr>
                        </table>

                        <!-- <base-input label="Aktivan" type="password" v-model="employee.password" placeholder="Aktivan">
                            <base-checkbox class="text-left" v-model="employee.active" />
                        </base-input> -->


                        <!-- <base-input label="Sektori" placeholder="Sektori">
                            <el-select v-model="employee.regions" class="select-primary" name="regions" value-key="id">
                                <el-option v-for="r in regions" class="select-primary" :label="r.name" :value="r"
                                    :key="r.id"></el-option>
                            </el-select>
                        </base-input> -->
                        <!-- <div class="form-group">
                            <base-checkbox>Subscribe to newsletter</base-checkbox>
                        </div> -->
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveKiosk()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3" @click="editKioskDialog = false; kiosk = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>

        <modal :show.sync="editKioskGroupDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="editKioskGroupDialog = false; kioskGroup = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form" v-if="kioskGroup">
                <h4 slot="header" class="card-title">Digitalni kiosk</h4>
                <form @submit.prevent>
                    <div>

                        <base-input label="Ime" type="text" v-model="kioskGroup.name" placeholder="Ime">
                        </base-input>

                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveKioskGroup()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3"
                            @click="editKioskGroupDialog = false; kioskGroup = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>


    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getKiosks()
        this.getKioskGroups()
    },
    data() {
        return {
            activeName: 'first',
            url: 'https://budva.scancar.org:8443/kuca',
            users: [],
            user: {},
            usersLoading: false,
            zonesLoading: false,
            user: {},
            editUserDialog: false,
            kiosks: [],
            kiosk: {},
            kiosksLoading: false,
            editKioskDialog: false,
            kioskGroups: [],
            kioskGroup: null,
            editKioskGroupDialog: false
        };
    },
    methods: {
        editKioskGroup() {
            if (!this.kioskGroup) {
                this.kioskGroup = {}
            }
            this.editKioskGroupDialog = true
        },
        getKioskGroups() {
            axios.get(this.url + '/kiosk/getKioskGroups').then(result => {

                if (result.data.result === 'ok') {
                    this.kioskGroups = result.data.kioskGroups
                } else {

                }
            })
        },
        getKiosks() {
            this.kiosksLoading = true
            const filter = {
                kioskGroup: this.kioskGroup
            }
            axios.post(this.url + '/kiosk/getKiosks', filter).then(result => {
                this.kiosksLoading = false

                if (result.data.result === 'ok') {
                    this.kiosks = result.data.kiosks
                } else {

                }
            })
        },
        saveKiosk() {
            this.loading = true
            axios.post(this.url + '/kiosk/saveKiosk', this.kiosk).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editKioskDialog = false
                    this.getKiosks()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveKioskGroup() {
            this.loading = true
            axios.post(this.url + '/kiosk/saveKioskGroup', this.kioskGroup).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editKioskGroupDialog = false
                    this.kioskGroup = null
                    this.getKioskGroups()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },

        deleteKiosk() {
            this.loading = true
            axios.get(this.url + '/kiosk/deleteKiosk?id=' + this.kiosk.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getKiosks()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteKioskPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete kiosk \"" + this.kiosk.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteKiosk()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        deleteGroup() {
            this.loading = true
            axios.get(this.url + '/kiosk/deleteGroup?id=' + this.kioskGroup.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.kioskGroup = null
                    this.getKioskGroups()
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getKiosks()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteGroupPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete grupu \"" + this.kioskGroup.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteGroup()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>